'use client';

import { AuthSessionHintBoundary } from '@/components/auth/auth-session-hint-boundary';
import { useAuthSessionObserver } from '@/lib/auth/auth-session-observer';

export function AuthSessionTransitionHost() {
  const sessionSnapshot = useAuthSessionObserver();
  const transition = sessionSnapshot.transition;
  if (transition?.phase !== 'validating') {
    return null;
  }

  return (
    <AuthSessionHintBoundary
      debugName={`auth-transition-${transition.direction}`}
      forceRead
      key={transition.id}
      publishToObserver
      revalidateOnMount
      transitionToken={{ id: transition.id }}
    >
      {() => null}
    </AuthSessionHintBoundary>
  );
}
